import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "mb-2 leading-7 text-sm font-medium text-gray-500" }, "対象生徒", -1)
const _hoisted_2 = {
  key: 0,
  class: "mb-6 flex flex-wrap border-b border-gray-500"
}
const _hoisted_3 = { class: "text-sm font-medium" }
const _hoisted_4 = {
  key: 1,
  class: "mb-6 flex flex-wrap items-center border-b border-gray-500 text-primary-500"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "py-1 text-sm font-medium text-gray-400" }, " 生徒が選択されていません ", -1)
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = {
  key: 2,
  class: "w-full p-2 mt-3 rounded-md bg-white shadow"
}
const _hoisted_8 = {
  key: 0,
  class: "text-secondary-500 w-16 flex justify-center"
}
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 追加 ")
const _hoisted_10 = { class: "flex flex-col ml-2" }
const _hoisted_11 = { class: "text-sm font-medium" }
const _hoisted_12 = { class: "text-gray-500 text-xs" }
const _hoisted_13 = { class: "flex flex-col md:flex-row mt-3" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 全教室の全生徒を選択 ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 全生徒の選択を解除 ")
const _hoisted_16 = { class: "flex flex-col md:flex-row mt-3" }
const _hoisted_17 = { class: "md:flex mt-2 mb-2 md:mt-0 md:mb-0 md:mr-1" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" の全生徒を選択 ")
const _hoisted_19 = {
  key: 3,
  class: "flex flex-col md:flex-row mt-3"
}
const _hoisted_20 = { class: "md:mr-1 mb-2 md:mb-0" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" の全生徒を選択 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_select_box = _resolveComponent("m-select-box")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    (_ctx.selectedStudents.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedStudents, (student) => {
            return (_openBlock(), _createBlock("div", {
              key: student.ref.id,
              class: "p-1 pl-2 mb-2 mr-3 flex items-center rounded-md border border-secondary-500"
            }, [
              _createVNode("p", _hoisted_3, _toDisplayString(student.data.name), 1),
              _createVNode("div", {
                class: "p-1 ml-1 text-gray-500 cursor-pointer",
                onClick: ($event: any) => (_ctx.removeStudent(student.ref.id))
              }, [
                _createVNode(_component_m_icon, { type: "close" })
              ], 8, ["onClick"])
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createBlock("div", _hoisted_4, [
          _createVNode(_component_m_icon, {
            type: "warning",
            size: "6",
            class: "mr-2"
          }),
          _hoisted_5
        ])),
    _createVNode("div", _hoisted_6, [
      _withDirectives(_createVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.studentSearchKeyword = $event)),
        type: "text",
        name: "searchStudent",
        placeholder: "名前かIDで生徒を検索...",
        onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.searchStudents && _ctx.searchStudents(...args))),
        class: "flex-grow bg-primary-100 rounded-md border border-primary-100 focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
      }, null, 544), [
        [_vModelText, _ctx.studentSearchKeyword]
      ])
    ]),
    (_ctx.searchedStudents.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_7, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.searchedStudents, (student, i) => {
            return (_openBlock(), _createBlock("div", {
              key: student.ref.id,
              class: ["flex items-center py-1 border-gray-200", { 'border-b': i < _ctx.searchedStudents.length - 1 }]
            }, [
              (_ctx.selectedStudentIds.includes(student.ref.id))
                ? (_openBlock(), _createBlock("div", _hoisted_8, [
                    _createVNode(_component_m_icon, {
                      type: "check-circle",
                      size: "6"
                    })
                  ]))
                : (_openBlock(), _createBlock(_component_m_button, {
                    key: 1,
                    text: "",
                    onClick: ($event: any) => (_ctx.addStudent(student.ref.id)),
                    class: "w-16 text-center"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9
                    ]),
                    _: 2
                  }, 1032, ["onClick"])),
              _createVNode("div", _hoisted_10, [
                _createVNode("p", _hoisted_11, _toDisplayString(student.data.name), 1),
                _createVNode("p", _hoisted_12, _toDisplayString(student.data.id), 1)
              ])
            ], 2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_13, [
      _createVNode(_component_m_button, {
        onClick: _ctx.addAllStudents,
        class: "mr-4"
      }, {
        default: _withCtx(() => [
          _hoisted_14
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_m_button, {
        onClick: _ctx.removeAllStudents,
        color: "red-400",
        "hover-color": "red-500",
        outline: "",
        disabled: _ctx.selectedStudentIds.length === 0
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode("div", _hoisted_17, [
        (_ctx.classroomNames.length > 0)
          ? (_openBlock(), _createBlock(_component_m_select_box, {
              key: 0,
              name: "classroom",
              placeholder: "（教室名）",
              options: _ctx.classroomNames,
              value: _ctx.focusedClassroom,
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.focusedClassroom = $event))
            }, null, 8, ["options", "value"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.classroomNames.length > 0)
        ? (_openBlock(), _createBlock(_component_m_button, {
            key: 0,
            onClick: _ctx.addClassroomStudents,
            disabled: !_ctx.focusedClassroom
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.groupTitles.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode(_component_m_select_box, {
              name: "group",
              placeholder: "（グループ名）",
              options: _ctx.groupTitles,
              value: _ctx.focusedGroup,
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.focusedGroup = $event))
            }, null, 8, ["options", "value"])
          ]),
          _createVNode(_component_m_button, {
            onClick: _ctx.addGroupStudents,
            disabled: !_ctx.focusedGroup
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          }, 8, ["onClick", "disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}